import Vuex from 'vuex';
import Vue from 'vue';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    tickets: [],
  },
  actions: {
    loadTickets() {
      axios
        .get('http://cc-tickets.test/api/events/5/tickets/1/order-tickets')
        .then((response) => {
        this.commit('SET_TICKETS', response.data.data.tickets)
      })
    },
    checkTicketInOrOut({commit, dispatch}, payload){
      return new Promise((resolve, reject) => {
        var form = {
            uid: payload.uid,
            manual: true
        }
        axios
        .post('http://cc-tickets.test/api/' + payload.path, form)
        .then((response) => {
          resolve(response)
          if(response.data.success){
            this.commit('UPDATE_TICKET', response.data.data.ticket)
          }
        }, error => {
          reject(error);
        })
      })
    }
  },
  mutations: {
    SET_TICKETS (state, tickets){
      state.tickets = tickets
    },
    UPDATE_TICKET (state, newTicketState){
      console.log('Items: ' + state.tickets.length)
      const ticket = state.tickets.find(item => item.id === newTicketState.id);
      Object.assign(ticket, newTicketState);
    }
  }
});